import React from "react";
import { DoubleTagIcon } from "@/utils/miscIcons";
import s from "@/components/OrderSummary/OrderSummary.module.scss";

const TotalSavings = ({ type, savings, label }) => {
  switch (type) {
    case "boxed":
      return (
        <div className={s.savings__container}>
          <div className={s.savings__label}>
            <DoubleTagIcon /> {label && label}
          </div>
          <div>{savings && savings}</div>
        </div>
      );

    default:
      return (
        <div className={`${s["orderSummary__savingsLabel--cont"]} ${s.bottom}`}>
          <div data-testid="total-savings-label" className={s.orderSummary__savingsLabel}>
            {label && label}
          </div>
          <div data-testid="total-savings" className={s.orderSummary__savingsLabel}>
            -{savings && savings}
          </div>
        </div>
      );
  }
};

export default TotalSavings;
